export default "__VITE_ASSET__Bv0kaZIu__"